import { Modal } from "antd";
import React from "react";
import styles from "./ProductImages.module.scss";
interface ImagesProps {
  imagesModal: boolean;
  setImagesModal: (value: boolean) => void;
  images: string[];
}
const ProductImages: React.FC<ImagesProps> = ({
  imagesModal,
  setImagesModal,
  images,
}) => {
  return (
      <Modal
        title={"Məhsulun şəkilləri"}
        open={imagesModal}
        onCancel={() => setImagesModal(false)}
        footer={null}
        width={"auto"}
        style={{ minWidth: "340px" }}
        centered
      >
        <div className={styles.product_images}>
          {images?.map((img, idx) => {
            return (
              <div key={idx} className={styles.img}>
                <img src={img} alt="product" />
              </div>
            );
          })}
        </div>
      </Modal>
  );
};

export default ProductImages;
